<template>
  <div class="senior-setup">
    <!-- <el-form label-position="top" label-width="80px">
      <el-form-item label="审批同意时是否签字">
        <el-switch inactive-text="无需签字" active-text="需要签字"
                   v-model="settings.sign"  @change="updateSign"></el-switch>
        <div class="sign-tip">如果此处设置为 <b>需要签字</b>，则所有审批人“同意时” <b>必须签字</b></div>
      </el-form-item>
    </el-form> -->
    <!-- <div class="setup-menu">
      <div :class="[currentMenu == 1 ? 'item-menu item-menu-current' : 'item-menu']" @click="toggleMenu(1)">流程高级设置</div>
      <div :class="[currentMenu == 2 ? 'item-menu item-menu-current' : 'item-menu']"  @click="toggleMenu(2)">权限管理</div>
    </div> -->
    <!-- 流程高级设置 -->
    <div class="setup-main-1" v-if="currentMenu == 1">
      <!-- {{ autoDeduplicationSettings }} -->
      <!-- <hr> -->
      <div class="item-setup">
        <div class="setup-top-con">
         
          <div class="img"><img src="@/assets/img/formDesign/icon-quchong.png"></div>
          <el-switch v-model="autoDeduplicationSettings.enable" inactive-color="#E4F7F4" active-color="#00B498"  @change="updateProAutoDedup('enable',$event)"></el-switch>
        </div>
        <div class="setup-title-con"> 
          <div class="name">自动去重</div>
          <div class="more" @click="onFixRepeat">更多</div>
        </div>
        <div class="setup-info">审批流程中审批人重复出现时，只需审批一次其余自动通过。</div>
      </div>
      <div class="item-setup">
        <div class="setup-top-con">
          <div class="img"><img src="@/assets/img/formDesign/icon-addshenpiren.png"></div>
          <el-switch v-model="settings.allowAddApprovers" inactive-color="#E4F7F4" active-color="#00B498"  @change="updateSign('allowAddApprovers',$event)"></el-switch>
        </div>
        <div class="setup-title-con"> 
          <div class="name">允许添加审批人</div>
        </div>
        <div class="setup-info">开启后审批流程可以新增临时审批人。</div>
      </div>
      <div class="item-setup">
        <div class="setup-top-con">
          <div class="img"><img src="@/assets/img/formDesign/icon-chexiao.png"></div>
          <el-switch v-model="settings.allowRevocation" inactive-color="#E4F7F4" active-color="#00B498"  @change="updateSign('allowRevocation',$event)"></el-switch>
        </div>
        <div class="setup-title-con"> 
          <div class="name" v-if="isProcess">撤销</div>
          <div class="name" v-else>撤销/修改</div>
        </div>
        <div class="setup-info">开启后发起人可以撤销审批中的审批。</div>
      </div>
      <div class="item-setup">
        <div class="setup-top-con">
          <div class="img"><img src="@/assets/img/formDesign/icon-xianshi.png"></div>
          <el-switch v-model="timeLimitedApproval.enable" inactive-color="#E4F7F4" active-color="#00B498"  @change="updateProTimeLimited('enable',$event)"></el-switch>
        </div>
        <div class="setup-title-con"> 
          <div class="name">限时审批</div>
          <div class="more" @click="onTimeLimited">更多</div>
        </div>
        <div class="setup-info">设置审批时间限制，自动审批。</div>
      </div>
      <div class="item-setup" v-if="isProcess">
        <div class="setup-top-con">
          <div class="img"><img src="@/assets/img/formDesign/icon-beizhu.png"></div>
          <el-switch v-model="settings.mustApproveRemark" inactive-color="#E4F7F4" active-color="#00B498"  @change="updateSign('mustApproveRemark',$event)"></el-switch>
        </div>
        <div class="setup-title-con"> 
          <div class="name">审批备注必填</div>
        </div>
        <div class="setup-info">审批流程中审批人/办理人审批时，必须填写备注。</div>
      </div>
      <!-- <div class="item-setup">
        <div class="setup-top-con">
          <div class="img"><img src="@/assets/img/formDesign/icon-tongzhi.png"></div>
          <el-switch v-model="notificationSettings.enable" inactive-color="#E4F7F4" active-color="#00B498"  @change="updateProNotice('enable',$event)"></el-switch>
        </div>
        <div class="setup-title-con"> 
          <div class="name">消息通知</div>
          <div class="more" @click="onMessageSetting">更多</div>
        </div>
        <div class="setup-info">设置审批流转过程中是否需要通知相关节点人。</div>
      </div> -->
    </div>
    <!-- 权限管理 -->
    <div class="setup-main-2" v-if="currentMenu == 2">
      <div class="item-permissions" v-for ="(item, index) in permissionsList" :key="index">
        <div class="title-con">
          <div class="name">权限组<span v-if="index != 0">{{ index }}</span></div>
          <div class="btn-del" @click="delPermissions(index)" v-if="index != 0"><i class="icon-close" />删除</div>
        </div>
        <div class="row-con">
          <div class="label">权限成员</div>
          <el-select v-model="item.person" @click.native="selectUser('admin')" value-key="name"
                    class="select-u"
                    size="small" clearable multiple>
            <el-option v-for="(wc, index) in item.admin" :label="wc.name" :key="index" :value="wc"></el-option>
          </el-select>
        </div>
        <div class="row-con">
          <div class="label">管理范围</div>
          <el-radio-group v-model="item.manageScope" class="check-group">
            <el-radio :label="1"><span class="name-text">自己负责的</span></el-radio>
            <el-radio :label="2"><span class="name-text">全公司</span></el-radio>
            <el-radio :label="3"><span class="name-text">下属的</span></el-radio>
          </el-radio-group>
        </div>
        <div class="row-con">
          <div class="label">操作权限</div>
          <el-checkbox-group v-model="item.operateScope"  class="check-group">
            <el-checkbox :label="1"><span class="name-text">打印</span></el-checkbox>
            <el-checkbox :label="2"><span class="name-text">查看</span></el-checkbox>
            <el-checkbox :label="3"><span class="name-text">导出</span></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <el-button type="primary" icon="el-icon-plus"  plain class="btn-new" @click="addPermissions">新增权限组</el-button>
      <div class="form-other-set">
        <div class="lable-title">权限组外人员查看权限</div>
        <el-radio-group v-model="otherScope" class="check-group">
            <el-radio :label="1"><span class="name-text">权限组外人员即公司组织内的所有人员均可查看审批详情</span></el-radio>
            <el-radio :label="2"><span class="name-text">权限组内人员以及表单流程内相关人员可查看审批详情</span></el-radio>
          </el-radio-group>
      </div>
    </div>
    <!-- 浮层 -->
    <auto-fix-repeat ref="AutoFixRepeat" ></auto-fix-repeat>
    <time-limited ref="TimeLimited"></time-limited>
    <message-setting ref="MessageSetting"></message-setting>
    <org-picker title="请选择权限成员" multiple ref="orgPicker" :selected="select" @ok="selected"></org-picker>
  </div>
</template>

<script>
import AutoFixRepeat from "../components/FormProDialog/autoFixRepeat.vue";
import TimeLimited from "../components/FormProDialog/timeLimited.vue";
import MessageSetting from "../components/FormProDialog/messageSetting.vue";
import OrgPicker from "@/components/OrgPicker";

export default {
  name: "FormProSetting",
  // computed: {
  //   setup() {
  //     return this.$store.state.design.settings;
  //   }
  // },
  components: {
    AutoFixRepeat,TimeLimited,MessageSetting,OrgPicker
  },
  props: {
    isProcess: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      // settings: {...this.$store.state.design.settings},
      // autoDeduplicationSettings: {...this.$store.state.design.settings.autoDeduplicationSettings},
      // timeLimitedApproval: {...this.$store.state.design.settings.timeLimitedApproval},
      // notificationSettings: {...this.$store.state.design.settings.notificationSettings},
      currentMenu:1,
      permissionsList: [
        {
          manageScope:1,
          operateScope:[1,2,3],
        }
      ],
      otherScope:1,
      select:[]
    }
  },
  computed: {
    settings(){
      return {...this.$store.state.design.settings}
    },
    autoDeduplicationSettings() {
      return  {...this.$store.state.design.settings.autoDeduplicationSettings}
    },
    timeLimitedApproval(){
      return  {...this.$store.state.design.settings.timeLimitedApproval}
    },
    notificationSettings(){
      return  {...this.$store.state.design.settings.notificationSettings}
    },
  },
  methods:{
    updateProAutoDedup(key,value){
      this.$store.commit("updateProAutoDedup",{key,value});
    },
    updateProTimeLimited(key,value){
      this.$store.commit("updateProTimeLimited",{key,value});
    },
    updateProNotice(key,value){
      this.$store.commit("updateProNotice",{key,value});
    },
    updateSign(key,value){
      // let key = 'sign'
      this.$store.commit("updatePro",{key,value});
    },
    toggleMenu(index){
      this.currentMenu = +index
    },
    // 去重
    onFixRepeat(){
      this.$refs.AutoFixRepeat.show()
    },
    // 限时审批
    onTimeLimited(){
      this.$refs.TimeLimited.show()
    },
    // 消息通知
    onMessageSetting(){
      this.$refs.MessageSetting.show()
    },
    selectUser() {
      this.$refs.orgPicker.show()
    },
    selected(){},
    validate(){
      return []
    },
    // 新增权限组
    addPermissions(){
      this.permissionsList.push({
        manageScope:1,
        operateScope:[1,2,3],
      })
    },
    // 删除权限组
    delPermissions(index){
      this.permissionsList.splice(index,1)
    },
  }
}
</script>

<style lang="scss" scoped>
.senior-setup {
  // overflow: auto;
  // margin: 0 auto;
  // width: 600px;
  min-height: calc(100vh - 273px);
  // background: #ffffff;
  // margin-top: 10px;
  // padding: 15px 20px;

  // .sign-tip {
  //   color: #949495;
  //   font-size: small;
  //   margin-left: 20px;
  // }
  // padding: 32px 0 0 32px;
  display: flex;
  // flex-wrap: wrap;
  .setup-menu{
    width: 250px;
    border-right: 1px solid #EDF2F2;
    box-sizing: border-box;
    padding-top: 32px;
    .item-menu{
      line-height: 54px;
      font-size: 16px;
      color: #939696;
      padding-left: 18px;
      position: relative;
      cursor: pointer;
      &:hover{
        color: #2F3030 ;
      }
    }
    .item-menu-current{
      color: #2F3030;
      &::before{
        content: '';
        position: absolute;
        left: 0;
        top: 19px;
        width: 2px;
        height: 16px;
        background-color: #00B498;
      }
    }
  }
  .setup-main-1{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 32px 0 84px 32px;
  }
  .item-setup {
    min-width: 250px;
    // width: calc(33% - 32px);
    width: calc(25% - 32px);
    background-color: #F8FAFA;
    border-radius: 8px;
    margin:0 32px 32px 0;
    box-sizing: border-box;
    padding: 16px 14px 14px 16px;
  }
  .setup-top-con{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .setup-title-con{
    display: flex;
    align-items: center;
    padding: 4px 0 4px 0;
    .name{
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #2F3030;
      margin-right: 8px;
    }
    .more{
      width: 32px;
      height: 18px;
      background: #E4F7F4;
      border-radius: 9px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #00B498;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
  .setup-info{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #939696;
    line-height: 22px;
  }
  // 权限管理
  .setup-main-2{
    padding: 16px;
    width: 100%;
    box-sizing: border-box;
    .name-text{
        font-size: 14px;
        color: #2F3030;
      }
    .item-permissions{
      background: #F8FAFA;
      border-radius:8px;
      margin-bottom: 24px;
      padding: 16px 16px 2px;
      .title-con{
        display: flex;
        padding:8px 0 14px 0;
        .name{
          font-weight: bold;
          font-size: 14px;
          color: #2F3030;
          margin-right: 20px;
        }
      }
      .btn-del{
        display: inline-flex;
        align-items: center;
        color: #00B498;
        cursor: pointer;
        font-size: 14px;
      }
      .icon-close {
        display: inline-block;
        width: 16px;
        height: 16px;
        cursor: pointer;
        margin-right: 2px;
        background-repeat: no-repeat;
        background-size: 16px 16px;
        background-position: center;
        background-image: url('~@/pages/officeApproval/common/icon/icon-del.png');
      }
      .select-u{
        width: 408px;
      }
      .row-con{
        display: inline-flex;
        align-items: center;
        width: 100%;
        margin-bottom: 20px;
        .label{
          font-size: 14px;
          color: #2F3030;
          display: inline-block;
          width: 64px;
        }
        /deep/{
          .el-radio,
          .el-checkbox{
            width: 128px;
            margin-right: 0;
          }
        }
      }
    }
    .btn-new{
      display: block;
      width: 100%;
    }
    .form-other-set{
      padding-top: 30px;
      .lable-title{
        font-weight: bold;
        font-size: 14px;
        color: #2F3030;
        margin-bottom: 10px;
      }
      /deep/.el-radio{
        display: block;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
